import { paymentSettingConstants } from "../constants/paymentSettingConstants";

const initialState = {
  sending: false,
  settingStatus: {},
  paymentSetting: {},
  error: {}
};

export default function paymentSettingReducer(state = initialState, action) {
  switch (action.type) {
    case paymentSettingConstants.ADD_PAYSETTING_REQUEST:
      return {
        sending: true
      };
    case paymentSettingConstants.ADD_PAYSETTING_SUCCESS:
      return {
        ...state,
        settingStatus: action.data
      };
    case paymentSettingConstants.ADD_PAYSETTING_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case paymentSettingConstants.GET_PAYSETTING_REQUEST:
      return {
        sending: true
      };
    case paymentSettingConstants.GET_PAYSETTING_SUCCESS:
      return {
        ...state,
        paymentSetting: action.data
      };
    case paymentSettingConstants.GET_PAYSETTING_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/paymentSettingReducer.js